<template>
    <div class="preview_card" style="position: relative">
        <a @click="onClickPreviewPage($event, data_page)"
           style="text-decoration: none">
            <div style="position:relative; margin-bottom: 15px;" class="img-preview-center"
                 :style="{width: data_page.data_image.width*ratio +'pt', height: data_page.data_image.height * ratio +'pt'}">
<!--                <div v-if="!isLoad"-->
<!--                     style="text-align: center"-->
<!--                >-->
<!--                    <FAIcon icon="fa fa-spin fa-spinner" />-->
<!--                </div>-->
                <canvas ref="canvas"
                        :class="[noPagePlagCurrentPopup === data_page['pageId'] ? 'd_card_for_page_current':'']"
                        class="d_card_for_page img-preview-center"
                        style="position: absolute; left: 0; top: 0; z-index: 0"
                ></canvas>
                <canvas ref="highlight-canvas" style="position:absolute; left: 0; top: 0; z-index: 1;"></canvas>

            </div>
            <div class="page_num_for_preview"
                 style="text-align: center;"
                 :class="[noPagePlagCurrentPopup === data_page['pageId'] ? 'page_active':'']">
                {{ data_page['pageId'] }}
            </div>
        </a>

    </div>
</template>

<script>

import {ColorPlagIgnored, ColorPlagLevel, ColorPlagUserIgnored} from '@/constants/ThemeConstant'
import {apiDownloadAsArrayBuffer} from '@/services/document_management_service'
import {getLevelPlagiarism} from '@/services/doit_result_service'

export default {
    name: 'PreviewResult',
    components: {},
    props: {
        data_page: {
            type: Object
        },
        index: {
            type: Number
        },
        isLoaded: {
            type: Boolean
        }
    },
    data: function () {
        return {
            ratio: 0.2,
        }
    },
    mounted() {
        if (this.isLoaded) {
            this.redrawCanvas()
            this.redrawHighlightCanvas()
        }
    },
    methods: {
        async redrawCanvas() {
            let canvasElement = this.$refs.canvas
            let ctx = canvasElement.getContext('2d')
            canvasElement.style.width = '100%'
            canvasElement.style.height = '100%'

            canvasElement.width = canvasElement.offsetWidth
            canvasElement.height = canvasElement.offsetHeight

            const url = this.data_page.data_image.url

            ctx.drawImage(await createImageBitmap(new Blob([new Uint8Array(await apiDownloadAsArrayBuffer(url))])), 0, 0, canvasElement.offsetWidth, canvasElement.offsetHeight)

            canvasElement.oncontextmenu = function (e) {
                e.preventDefault()
            }
        },
        redrawHighlightCanvas() {
            let highlightCanvas = this.$refs['highlight-canvas']
            let highlightCtx = highlightCanvas.getContext('2d')

            highlightCanvas.style.width = '100%'
            highlightCanvas.style.height = '100%'

            highlightCanvas.width = highlightCanvas.offsetWidth
            highlightCanvas.height = highlightCanvas.offsetHeight

            highlightCtx.clearRect(0, 0, highlightCanvas.width, highlightCanvas.height)

            const pt2px = (pt) => {
                return pt * 4 / 3
            }

            if (this.documentResultMode === 'plagiarismMode') {
                const data_plagiarism = this.data_page.data_plagiarism
                for (const groupId in data_plagiarism) {
                    const highlightList = []
                    data_plagiarism[groupId].parts.forEach(part => highlightList.push(...part.highlights))
                    const levelPlag = this.getLevelPlag(data_plagiarism[groupId])
                    highlightList.forEach((line) => {
                        highlightCtx.beginPath()
                        highlightCtx.rect(pt2px(line.left * this.ratio), pt2px(line.top * this.ratio), pt2px(line.width * this.ratio), pt2px(line.height * this.ratio))
                        highlightCtx.fillStyle = levelPlag
                        highlightCtx.fill()
                    })
                }

            } else if (this.documentResultMode === 'spellingMode') {
                this.data_page.data_spelling.forEach((value) => {
                    highlightCtx.beginPath()
                    highlightCtx.rect(pt2px(value.left * this.ratio), pt2px(value.top * this.ratio), pt2px(value.width * this.ratio), pt2px(value.height * this.ratio))
                    highlightCtx.fillStyle = 'rgba(255, 0, 0, 0.5)'
                    highlightCtx.fill()
                })
            }

            highlightCanvas.oncontextmenu = function (e) {
                e.preventDefault()
            }
        },
        onClickPreviewPage(e, data_page) {
            // console.log(data_page)
            // TODO: Uncomment this after implement main result view
            document.getElementById(`page-${data_page.pageId}`).scrollIntoView({
                behavior: 'auto'
            })
        },
        getLevelPlag(result_plag) {
            if (result_plag['isIgnoredBySystem']) {
                return ColorPlagIgnored
            }
            if (result_plag['isIgnored']){
                return ColorPlagUserIgnored
            }
            return ColorPlagLevel[getLevelPlagiarism(result_plag.score, this.configDocumentScore)] || ColorPlagLevel['unknown']
        },
    },
    computed: {
        noPagePlagCurrentPopup() {
            // console.log('noPageCurrentPopup', this.$store.getters['docRes/plagiarism/noPlagCurrentPopup'])
            // console.log('pageid', this.data_page.pageId)
            return this.$store.getters['docRes/plagiarism/noPlagCurrentPopup']
        },
        documentResultMode() {
            return this.$store.getters['docRes/documentResultMode']
        },
        lstResultPlagIgnoredCurrent() {
            return this.$store.getters['docRes/plagiarism/lstResultPlagIgnoredCurrent']
        },
        lstIgnoredByUser() {
            return this.$store.getters['docRes']
        },
        configDocumentScore() {
            return this.$store.getters['docRes/plagiarism/getConfigDocumentScore']
        },
    },
    watch: {
        data_page: function () {
            this.redrawHighlightCanvas()
        },
        documentResultMode: function () {
            this.redrawHighlightCanvas()
        },
        lstResultPlagIgnoredCurrent: function () {
            this.redrawHighlightCanvas()
        },
        isLoaded: function (newVal, oldVal) {
            if (!oldVal && newVal) {
                this.redrawCanvas()
                this.redrawHighlightCanvas()
            }
        }
    }
}
</script>

<style scoped>
.preview_card {
    cursor: pointer;
}

.page_num_for_preview {
    font-size: 15px;
    color: #6c757d;
    /*margin-left: 75px;*/
    /*margin-top: 5px;*/
    margin-bottom: 25px;
}

.page_active {
    font-weight: bold;
    font-size: 18px;
}

.img-preview-center {
    display: block;
    margin-right: auto;
    margin-left: auto;
}
</style>
